/**
 * jn-set-builder.js
 * ---------------------------------------------------------------------------
 * Drives the "Complete the set" builder rendered by snippets/jn-set-builder.liquid
 * on bra PDPs. Full price only — no discounts, no savings messaging.
 *
 *  - Pre-selects a saved panty size (customer metafield klaviyo.QuizPanty, else the
 *    jfq_dress_sz quiz cookie/localStorage). Never guesses from bra size.
 *  - A piece can only be toggled on once a valid, in-stock size is chosen.
 *  - Keeps a live running total (bra + toggled pieces) at full price, announced to
 *    screen readers, and mirrors it into the mobile sticky bar.
 *  - On add-to-cart, adds the bra + every toggled piece in ONE /cart/add.js items[]
 *    call, each line carrying a hidden _set line-item property, then opens the
 *    existing cart drawer via the theme's own events. Every line stays a normal SKU.
 *
 * Re-mountable: family_products is per-colorway, so a colour swatch loads a
 * sibling product with its OWN set. window.JNSetBuilder.reloadForHandle(handle)
 * re-fetches the sibling's set-builder HTML and re-binds. The document-level ATC
 * hooks are registered ONCE and always act on the currently mounted instance.
 */
(function () {
  'use strict';

  var active = null;               // currently mounted instance, or null
  var moneyFormat = '${{amount}}';
  var pageForm = null;             // cached main product form (stable across colour swatches)

  // The page's main product <form> (the one the ATC button submits). Cached once; the
  // set-builder's own data-form can point at a sibling after a re-mount, so prefer the
  // actual on-page form, falling back to the builder's data-form only as a last resort.
  function mainProductForm(builder) {
    if (pageForm && document.contains(pageForm)) return pageForm;
    // First mount: the builder's data-form IS the correct main form id (same as the
    // original resolution), so prefer it; cache it and reuse on re-mounts (when the
    // swapped builder would carry a sibling's id instead).
    var formId = builder && builder.getAttribute('data-form');
    pageForm =
      (formId && document.getElementById(formId)) ||
      document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]') ||
      null;
    return pageForm;
  }

  /* ---- money formatting (standard Shopify algorithm) --------------------- */
  function formatMoney(cents) {
    cents = typeof cents === 'number' ? cents : parseInt(cents, 10) || 0;
    function defaultTo(v, d) { return (v == null || v === '') ? d : v; }
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }
    var value = '';
    var match = moneyFormat.match(placeholder);
    var fmt = match ? match[1] : 'amount';
    switch (fmt) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return moneyFormat.replace(placeholder, value);
  }

  /* ---- cookies / saved size --------------------------------------------- */
  function getCookie(n) {
    var c = document.cookie.split(';').map(function (s) { return s.trim(); })
      .find(function (s) { return s.startsWith(n + '='); });
    return c ? decodeURIComponent(c.slice(n.length + 1)) : null;
  }
  var PANTY_ALIASES = {
    XS:  ['XS', 'EXTRA SMALL', 'X-SMALL', 'X SMALL'],
    S:   ['S', 'SMALL'],
    M:   ['M', 'MEDIUM'],
    L:   ['L', 'LARGE'],
    XL:  ['XL', 'EXTRA LARGE', 'X-LARGE'],
    XXL: ['XXL', 'EXTRA EXTRA LARGE', '2XL', 'XX-LARGE']
  };
  function dressToLetter(n) {
    n = parseFloat(n);
    if (isNaN(n)) return '';
    if (n <= 2) return 'XS';
    if (n <= 6) return 'S';
    if (n <= 10) return 'M';
    if (n <= 14) return 'L';
    if (n <= 18) return 'XL';
    return 'XXL';
  }
  function savedPantySize(builder) {
    var fromMeta = (builder.getAttribute('data-saved-panty') || '').trim();
    if (fromMeta) return fromMeta.toUpperCase();
    try {
      var raw = getCookie('jfq_dress_sz') || localStorage.getItem('jfq_dress_sz');
      var ds = JSON.parse(raw || 'null');
      if (ds && ds.pantySize) return String(ds.pantySize).toUpperCase();
      if (ds && ds.dressSize != null) { var l = dressToLetter(ds.dressSize); if (l) return l; }
    } catch (e) {}
    var dmeta = (builder.getAttribute('data-saved-dress') || '').trim();
    if (dmeta) { var l2 = dressToLetter(dmeta); if (l2) return l2; }
    return '';
  }

  /* ---- mount an instance against a builder element ----------------------- */
  function mount(builder) {
    // No set for this colourway: tear down and restore the ATC button label.
    if (!builder) { resetAtcButtons(); active = null; return; }

    // Use the PAGE's main product form (stable across colour swatches). The builder's
    // own data-form can be a sibling product's form id after a re-mount, so don't trust it.
    var form = mainProductForm(builder);
    if (!form) { active = null; return; }

    moneyFormat = builder.getAttribute('data-money-format') || '${{amount}}';
    var setToken = builder.getAttribute('data-set-token') || '';

    var pieces = Array.prototype.map.call(builder.querySelectorAll('[data-jn-set-piece]'), function (row) {
      var sizeCtrl = row.querySelector('[data-jn-set-size]');
      var isSelect = sizeCtrl && sizeCtrl.tagName === 'SELECT';
      return {
        row: row,
        check: row.querySelector('[data-jn-set-check]'),
        sizeCtrl: sizeCtrl,
        priceEl: row.querySelector('[data-jn-set-price]'),
        hint: row.querySelector('[data-jn-set-hint]'),
        isSelect: isSelect,
        variantId: function () { var v = sizeCtrl && sizeCtrl.value; return v ? Number(v) : null; },
        unitPrice: function () {
          if (!sizeCtrl) return 0;
          if (isSelect) {
            var opt = sizeCtrl.options[sizeCtrl.selectedIndex];
            return opt ? (parseInt(opt.getAttribute('data-price'), 10) || 0) : 0;
          }
          return parseInt(sizeCtrl.getAttribute('data-price'), 10) || 0;
        }
      };
    });

    var inst = {
      builder: builder,
      form: form,
      setToken: setToken,
      braPrice: parseInt(builder.getAttribute('data-bra-price'), 10) || 0,
      pieces: pieces,
      totalWrap: builder.querySelector('[data-jn-set-total-wrap]'),
      totalValue: builder.querySelector('[data-jn-set-total]'),
      live: builder.querySelector('[data-jn-set-live]'),
      lastTotal: 0,
      lastCount: 0
    };

    function syncRowPrice(pc) { if (pc.priceEl) { var p = pc.unitPrice(); if (p) pc.priceEl.textContent = formatMoney(p); } }

    function atcButtons() {
      return Array.prototype.filter.call(
        form.querySelectorAll('button[type="submit"], input[type="submit"]'),
        function (b) { return !b.closest('.shopify-payment-button'); }
      );
    }
    function updateButtons(total, count) {
      atcButtons().forEach(function (b) {
        if (!('jnOrig' in b.dataset)) b.dataset.jnOrig = (b.textContent || '').trim();
        if (b.disabled) return;
        if (count > 0) b.textContent = 'Add ' + (count + 1) + ' items · ' + formatMoney(total);
        else if ('jnOrig' in b.dataset) b.textContent = b.dataset.jnOrig;
      });
    }
    function updateInstallments(total, count) {
      Array.prototype.forEach.call(document.querySelectorAll('shopify-payment-terms'), function (el) {
        if (count > 0) el.setAttribute('data-shopify-installments-amount', String(total));
        else el.removeAttribute('data-shopify-installments-amount');
      });
    }
    function updateSticky(total, count) {
      var bar = document.querySelector('product-sticky-bar [data-jn-set-sticky-total]');
      if (!bar) return;
      if (count > 0) { bar.textContent = 'Set total ' + formatMoney(total); bar.setAttribute('data-active', ''); bar.hidden = false; }
      else { bar.removeAttribute('data-active'); bar.hidden = true; }
    }

    function recalc(announce) {
      var total = inst.braPrice, count = 0;
      pieces.forEach(function (pc) {
        if (pc.check && pc.check.checked && pc.variantId()) { total += pc.unitPrice(); count++; }
      });
      inst.lastTotal = total; inst.lastCount = count;
      if (inst.totalValue) inst.totalValue.textContent = formatMoney(total);
      if (inst.totalWrap) inst.totalWrap.hidden = count === 0;
      if (announce && inst.live) {
        inst.live.textContent = count === 0
          ? 'Set cleared.'
          : count + (count === 1 ? ' piece' : ' pieces') + ' added. Add-to-cart total ' + formatMoney(total) + '.';
      }
      updateSticky(total, count);
      updateButtons(total, count);
      updateInstallments(total, count);
      return { total: total, count: count };
    }

    function toggledItems() {
      var items = [];
      pieces.forEach(function (pc) {
        if (pc.check && pc.check.checked) { var id = pc.variantId(); if (id) items.push({ id: id, quantity: 1, properties: { _set: setToken } }); }
      });
      return items;
    }
    function setBusy(on) {
      Array.prototype.forEach.call(form.querySelectorAll('[type="submit"]'), function (b) {
        if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
      });
    }
    function addSet(braId, extra) {
      var qtyInput = form.querySelector('[name="quantity"]');
      var braQty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var items = [{ id: braId, quantity: braQty, properties: { _set: setToken } }].concat(extra);
      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
      setBusy(true);
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: sections, sections_url: location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
          setBusy(false);
          if (!res.ok) {
            form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: (res.json && res.json.description) || 'Could not add set' } }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            return;
          }
          fetch(root + 'cart.js').then(function (c) { return c.json(); }).then(function (cart) {
            cart.sections = res.json.sections;
            var added = res.json.items ? res.json.items : [res.json];
            form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: added, cart: cart, onSuccessDo: 'force_open_drawer' } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cart } }));
          });
        })
        .catch(function () {
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
          setBusy(false);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
    }

    inst.recalc = recalc;
    inst.toggledItems = toggledItems;
    inst.addSet = addSet;
    inst.updateSticky = updateSticky;
    inst.setBraPrice = function (p) { inst.braPrice = p; recalc(false); };

    // Per-piece wiring (on this instance's fresh elements).
    pieces.forEach(function (pc) {
      if (pc.isSelect) {
        pc.sizeCtrl.addEventListener('change', function () {
          var hasSize = !!pc.sizeCtrl.value;
          if (pc.check) { pc.check.disabled = !hasSize; pc.check.checked = hasSize; }
          if (pc.hint) pc.hint.hidden = true;
          syncRowPrice(pc);
          recalc(true);
        });
      }
      if (pc.check) {
        pc.check.addEventListener('change', function () {
          if (pc.check.checked && !pc.variantId()) { pc.check.checked = false; if (pc.isSelect) pc.sizeCtrl.focus(); return; }
          recalc(true);
        });
      }
    });

    // Preselect a saved panty size.
    (function preselect() {
      var saved = savedPantySize(builder);
      if (!saved) return;
      var forms = PANTY_ALIASES[saved] || [saved];
      pieces.forEach(function (pc) {
        if (!pc.isSelect || pc.sizeCtrl.value) return;
        var opts = pc.sizeCtrl.options;
        for (var i = 0; i < opts.length; i++) {
          var o = opts[i];
          if (o.disabled || !o.value) continue;
          var sz = (o.getAttribute('data-size') || o.textContent || '').trim().toUpperCase();
          if (forms.indexOf(sz) > -1) {
            pc.sizeCtrl.value = o.value;
            if (pc.check) pc.check.disabled = false;
            if (pc.hint) pc.hint.hidden = false;
            syncRowPrice(pc);
            break;
          }
        }
      });
    })();

    active = inst;
    recalc(false);
  }

  // Restore any ATC button labels the builder had changed (used when a colour has no set).
  function resetAtcButtons() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-jn-orig]'), function (b) {
      if (!b.disabled) b.textContent = b.dataset.jnOrig;
    });
  }

  /* ---- document-level hooks (registered ONCE; act on `active`) ----------- */
  document.addEventListener('variant:change', function (e) {
    if (!active) return;
    var v = e.detail && e.detail.variant;
    if (v && typeof v.price === 'number') active.setBraPrice(v.price);
  });

  // Capture phase so we pre-empt the theme's <product-form> submit handler.
  document.addEventListener('submit', function (e) {
    if (!active || e.target !== active.form) return;
    var extra = active.toggledItems();
    if (!extra.length) return;                       // no pieces -> normal single-item add
    var idInput = active.form.querySelector('input[name="id"]');
    var braId = idInput && idInput.value;
    if (!braId) return;                              // bra size not chosen -> native prompt
    e.preventDefault();
    e.stopImmediatePropagation();
    active.addSet(Number(braId), extra);
  }, true);

  // The mobile sticky bar re-renders on bra variant changes, wiping the injected
  // set-total; re-apply after any such re-render.
  (function () {
    var bar = document.querySelector('product-sticky-bar');
    var target = bar && bar.parentElement;
    if (target && window.MutationObserver) {
      new MutationObserver(function () { if (active) active.updateSticky(active.lastTotal, active.lastCount); })
        .observe(target, { childList: true });
    }
  })();

  /* ---- re-render for a sibling colourway --------------------------------- */
  // Fetches the sibling product's main-product section, swaps the set-builder slot's
  // contents, and re-mounts. Falls back to clearing the slot if the sibling has no set.
  function reloadForHandle(handle) {
    var slot = document.querySelector('[data-jn-set-builder-slot]');
    if (!slot || !handle) return;
    var section = slot.closest('.shopify-section');
    if (!section || !section.id) return;
    var sid = section.id.replace(/^shopify-section-/, '');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(sid), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('section ' + r.status)); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var freshSlot = tmp.querySelector('[data-jn-set-builder-slot]');
        slot.innerHTML = freshSlot ? freshSlot.innerHTML : '';
        mount(slot.querySelector('[data-jn-set-builder]'));
      })
      .catch(function () { /* leave the current builder as-is on failure */ });
  }

  window.JNSetBuilder = { mount: mount, reloadForHandle: reloadForHandle };

  // Initial mount.
  mount(document.querySelector('[data-jn-set-builder]'));
})();
